// ABOUTME: The bottom navigation's fixed height, which the shell pads the content by, and the routes inside the
// ABOUTME: authenticated group that are full-screen flows and show no navigation.
import { PATHS } from 'config/paths';

export const NAV_HEIGHT = 80;

/** Full-screen flows: a talent in one of these is doing one thing and the navigation would only pull them out of it. */
export const NAV_FREE_PATHS: string[] = [PATHS.login, PATHS.cvBuilder];
